import { render, staticRenderFns } from "./VerificationForm.vue?vue&type=template&id=12e75d52"
import script from "./VerificationForm.vue?vue&type=script&lang=js"
export * from "./VerificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports